import { render, staticRenderFns } from "./MaybeLink.vue?vue&type=template&id=0803abd1&"
import script from "./MaybeLink.vue?vue&type=script&lang=js&"
export * from "./MaybeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports